export const SHOP = 'https://REPLACE_YOUR_DOMAIN'

export const VARIANTS = {
  starter: 'REPLACE_STARTER_ID',
  complete: 'REPLACE_COMPLETE_ID',
  upgrade: 'REPLACE_UPGRADE_7_ID',
  braveMind: 'REPLACE_BRAVE_MIND_89_ID',
  littleEngineer: 'REPLACE_LITTLE_ENGINEER_1999_ID',
  focusLab: 'REPLACE_FOCUS_LAB_1999_ID',
} as const

export type UpsellId = 'upgrade' | 'braveMind' | 'littleEngineer' | 'focusLab'

export type Upsell = {
  id: UpsellId
  title: string
  price: number
  compareAt?: number
  description: string
  thumbLabel: string
  starterOnly?: boolean
}

export const upsells: Upsell[] = [
  {
    id: 'upgrade',
    title: 'Upgrade to Complete',
    price: 7,
    description:
      'Emotions & Calm Corner Pack, The Focus Pack and free updates for life — the three things you just left behind.',
    thumbLabel: 'COMPLETE COVER',
    starterOnly: true,
  },
  {
    id: 'braveMind',
    title: 'Brave Mind — Personalized Meditations for Your Child',
    price: 89,
    compareAt: 149,
    description:
      "The one thing on this page you don't have to make. Five meditations recorded around your child's name and what they're struggling with — delivered in 5 business days.",
    thumbLabel: 'BRAVE MIND COVER',
  },
  {
    id: 'littleEngineer',
    title: 'Little Engineer Mega Kit',
    price: 19.99,
    compareAt: 27.99,
    description:
      '365 screen-free projects for boys and girls ages 4-10. What they DO once the routine is running.',
    thumbLabel: 'LITTLE ENGINEER COVER',
  },
  {
    id: 'focusLab',
    title: 'The Focus Lab',
    price: 19.99,
    compareAt: 29.99,
    description:
      '100+ printable brain-training exercises. One page a day, ten minutes, no screen.',
    thumbLabel: 'FOCUS LAB COVER',
  },
]

export function formatPrice(value: number): string {
  return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`
}

export function buildCartUrl(planVariant: string, extras: string[]): string {
  const items = [`${planVariant}:1`, ...extras.map(id => `${id}:1`)]
  return `${SHOP}/cart/${items.join(',')}`
}
